import api from './api';

export async function login(email, password) {
  const response = await api.post('/auth/login', { email, password, useCourtPortal: true });
  return response.data;
}

export async function requestPasswordReset(email) {
  const response = await api.post('/auth/forgot-password', { email });
  return response.data;
}

export async function resetPassword(token, newPassword) {
  const response = await api.post('/auth/reset-password', { token, newPassword });
  return response.data;
}

export async function getVenueOwnersForAdmin() {
  const response = await api.get('/admin/venue-owners');
  return response.data;
}

export async function createVenueOwnerSession(ownerId) {
  const response = await api.post(`/admin/venue-owners/${ownerId}/session`);
  return response.data;
}

export async function getProfile() {
  const response = await api.get('/auth/profile');
  return response.data;
}

export async function updateProfile(data) {
  const response = await api.put('/auth/profile', data);
  return response.data;
}

export async function changePassword(data) {
  const response = await api.put('/auth/password', data);
  return response.data;
}
